<div class="mat-elevation-z8">
  <div class="filter-actions-line">
    <app-select-search (selectedItemId)="onMarketReceived($event)"
      [selectItems]="selectMarketItems" selectTitle="Market" [setId]="marketId"></app-select-search>
    @if(screenid === '4'){
      <app-select-search (selectedItemId)="onCustomerReceived($event)"
        [selectItems]="selectCustomerItems" selectTitle="Customer" [setId]="generatorId"></app-select-search>
    }
    @else{
      <app-select-search (selectedItemId)="onSiteReceived($event)" [selectItems]="selectSiteItems"
        selectTitle="Sites" [setId]="siteInfo?.id"></app-select-search>
    }
    <app-select-search (selectedItemId)="onStatusReceived($event)" [selectItems]="selectStatusItems" selectTitle="Status"></app-select-search>

    <mat-form-field appearance="outline" style="width:260px">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
        <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start"
               (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)"
               (keydown)="onKeydown($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <mat-error *ngIf="range.touched && range.hasError('required')">
        Date range is required.
      </mat-error>
      <mat-error *ngIf="range.touched && range.hasError('incompleteRange')">
        Please enter valid dates..
      </mat-error>
    </mat-form-field>

    <button id="feedStockSearchButton" data-testid="feedStockSearchButton" mat-raised-button color="primary"
            style="margin-top: -3px" (click)="onSearch()">
      <mat-icon>search</mat-icon>Search
    </button>
  </div>
</div>
<div class="mat-elevation-z8 mar-top-10" style="background-color :#fff;">
  <div class="grid-toolbar">
    <div class="record-info noofrecords" [style.width]="!canShowBiomasTons ? '20%' : null">
      @if(screenid !== '4' && canShowBiomasTons){
        <div class="container">
          <div class="row-item">Total Biomass Tonnage Accepted - 12mo Rolling : <b [style.color]="csscolor">{{biomasTons}}</b> tons</div>
          <div class="row-item">Total Biomass Tonnage Limit 140,000 tons (includes AD and ORA food streams, plus manure)</div>
        </div>
      }
    </div>
    <div class="record-info">
      @if(controlPermissions.addButton){
        <button id="btnAddLoad" data-testid="btnAddLoad" mat-raised-button color="primary"
          (click)="onOpenLoadDialog(0, 'Add', null)">
          <mat-icon>add</mat-icon> Add Load
        </button>
      }
      <button id="btnUpdateStatus" data-testid="btnUpdateStatus" mat-raised-button class="btn-yellow"
        [disabled]="isUpdateDisabled()" (click)="updateStatus()">
        <mat-icon>sync</mat-icon> Update Status
      </button>

      @if(screenid == "1" && controlPermissions.addButton){
        <button data-testid="btnLockCodes" id="btnLockCodes" mat-raised-button color="primary"
          (click)="openLockCodesBySiteId()">
          <mat-icon>lock</mat-icon> Lock Codes
        </button>
      }

      @if(controlPermissions.dispatch_Button){
        <button id="btnDispatch" data-testid="btnDispatch" mat-raised-button class="btn-blue"
          [disabled]="checkedFsLoadIds.length === 0" (click)="dispatchLoads()">
          <mat-icon>mail</mat-icon> Dispatch
        </button>
      }
      <div class="custom-search-box" style="margin-top:10px">
        <mat-icon>search</mat-icon>
        <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event)" data-testid="txtsearch"
          placeholder="Search...">
      </div>
    </div>
    <div class="record-info"></div>
    
    <div class="record-info noofrecords" style="font-weight:bold">
      Showing {{dataSource?.data?.length || 0}} records
    </div>
    <!-- <button mat-icon-button class="settings-btn"
            (click)="openColumnDialog()"
            matTooltip="Choose Columns">
      <mat-icon>settings</mat-icon>
    </button> -->
  </div>
  <mat-card>
    <mat-card-content>
      <div class="gridheight mat-elevation-z8 viewport table-container" style="margin-top :-12px">
        <!--<cdk-virtual-scroll-viewport #viewport tvsItemSize="48" class=" gridheight">-->
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort [trackBy]="trackByFn">
          <ng-container matColumnDef="workOrderNumber" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small2"> Work Order # </th>
            <td mat-cell *matCellDef="let element" class="col-small2">
              <span [matTooltip]="element.createdByName || element.createdBy || ''"
                    matTooltipPosition="right" [matTooltipClass]="'wo-creator-tooltip'" class="wo-link">
                {{element.workOrderNumber}}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actualDate" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Received </th>
            <td mat-cell *matCellDef="let element"> {{ element.actualDate | date: 'MM/dd/yyyy HH:mm' }} </td>
          </ng-container>

          <ng-container matColumnDef="sampleStatusDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small">Sample Status</th>
            <td mat-cell *matCellDef="let element" class="col-small" [ngClass]="getSampleStatusCellColor(element)">
              {{ element.sampleStatusDescription }}
            </td>
          </ng-container>

          <ng-container matColumnDef="materialType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stream Group</th>
            <td mat-cell *matCellDef="let element">{{ element.materialType }}</td>
          </ng-container>

          <ng-container matColumnDef="generator">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
            <td mat-cell *matCellDef="let element">{{ element.generator }}</td>
          </ng-container>

          <ng-container matColumnDef="streamName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stream</th>
            <td mat-cell *matCellDef="let element">{{ element.streamName }}</td>
          </ng-container>

          <ng-container matColumnDef="pickupLocation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Pick Location</th>
            <td mat-cell *matCellDef="let element">{{ element.pickupLocation }}</td>
          </ng-container>

          <ng-container matColumnDef="siteName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Disposal Site</th>
            <td mat-cell *matCellDef="let element">{{ element.siteName }}</td>
          </ng-container>

          <ng-container matColumnDef="tankName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small2">Tank</th>
            <td mat-cell *matCellDef="let element" class="col-small2"> {{ element.tankName }}</td>
          </ng-container>

          <ng-container matColumnDef="unitOfMeasureName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small">Units</th>
            <td mat-cell *matCellDef="let element" class="col-small">{{ element.unitOfMeasureName }}</td>
          </ng-container>

          <ng-container matColumnDef="projected_Quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small">Projected <br />Quantity</th>
            <td mat-cell *matCellDef="let element" class="col-small">{{ element.projected_Quantity }}</td>
          </ng-container>

          <ng-container matColumnDef="hauler">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hauler</th>
            <td mat-cell *matCellDef="let element">{{ element.hauler }}</td>
          </ng-container>

          <ng-container matColumnDef="actual_Quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small">Actual<br />Quantity</th>
            <td mat-cell *matCellDef="let element" class="col-small">{{ element.actual_Quantity }}</td>
          </ng-container>

          <ng-container matColumnDef="actual_Volume_Gallons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small"> Actual <br />Vol(gal)</th>
            <td mat-cell *matCellDef="let element" class="col-small">{{ element.actual_Volume_Gallons }}</td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="col-smallXX"></th>
            <td mat-cell *matCellDef="let element" class="col-smallXX">
              <mat-checkbox *ngIf="element.statusDescription === 'Projected' || element.statusDescription === 'Confirmed'"
                            [(ngModel)]="element.isSelected" (change)="onCheckboxChange(element, $event)"
                            [disabled]="disableCheckBox(element)"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="statusDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small3">Status</th>
            <td mat-cell *matCellDef="let element" [ngClass]="getStatusCellClass(element)" class="col-small3">
              @if(controlPermissions.updateStatus){
                <span *ngIf="!element.isEditingStatus" (click)="onStatusClick(element)">
                  {{ element.statusDescription }}
                </span>

                <mat-form-field *ngIf="element.isEditingStatus" appearance="outline" class="status-dropdown">
                  <mat-select [(ngModel)]="element.status" (closed)="onStatusDropdownClose(element)">
                    <mat-option *ngFor="let status of fsStatus; trackBy: trackByFn" [value]="status.id"
                                [disabled]="status.description === 'Invoiced'">
                      {{ status.description }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              }
              @else{
                {{ element.statusDescription }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="loadSlipNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small">Load Slip#</th>
            <td mat-cell *matCellDef="let element" class="col-small">{{ element.loadSlipNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="customerReferenceNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-small">Customer <br />Ref#</th>
            <td mat-cell *matCellDef="let element" class="col-small">{{ element.customerReferenceNo }}</td>
          </ng-container>

          <ng-container matColumnDef="notesForCustomer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer <br />Notes</th>
            <td mat-cell *matCellDef="let element">{{ element.notesForCustomer }}</td>
          </ng-container>

          <ng-container matColumnDef="schedulingNotes">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Scheduling <br />Notes</th>
            <td mat-cell *matCellDef="let element">{{ element.schedulingNotes }}</td>
          </ng-container>

          <ng-container matColumnDef="notesForHauler">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hauler <br />Notes</th>
            <td mat-cell *matCellDef="let element">{{ element.notesForHauler }}</td>
          </ng-container>

          <ng-container matColumnDef="notesForDisposalSite">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Disposal <br />Site Notes</th>
            <td mat-cell *matCellDef="let element">{{ element.notesForDisposalSite }}</td>
          </ng-container>

          <ng-container matColumnDef="actions" sticky>
            <th mat-header-cell *matHeaderCellDef class="col-small">Actions</th>
            <td mat-cell *matCellDef="let row" [ngClass]="getActionsCellClass(row)" class="col-small">
              <div>
                <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                  (click)="loadMenuDataAndOpen(row, menuTrigger)" [disabled]="isRowDisabled(row)">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-icon [style.visibility]="row.loadSlip > 0 ? 'visible' : 'hidden'" (click)="openViewDocsDialog(row.id, row.workOrderNumber, row)">attach_file_add</mat-icon>
              </div>
              <mat-menu #menu="matMenu">
                <ng-container>
                  @if(this.controlPermissions.delete){
                  <button mat-menu-item (click)="onDeleteLoad(row.id, row.workOrderNumber)" *ngIf="canShowDelete(row)"
                          style="color: red;">
                    <mat-icon matListIcon color="warn">delete</mat-icon>
                    <span matLine>Delete Load</span>
                  </button>
                  }
                  @if(controlPermissions.duplicate){
                    <button (click)="onOpenLoadDialog(row.id, 'Duplicate', row)" mat-menu-item [disabled]="row.adsFlag">
                      <mat-icon matListIcon>content_copy</mat-icon>
                      <span matLine>Duplicate Load</span>
                    </button>
                  }
                  <button mat-menu-item (click)="onOpenLoadDialog(row.id, 'Edit', row)" [disabled]="row.adsFlag">
                    <mat-icon matListIcon>edit</mat-icon>
                    <span matLine>Edit</span>
                  </button>
                  @if(controlPermissions.addionalInfo){
                    <button mat-menu-item [disabled]="row.adsFlag"
                      (click)="addRevenue(row.id, row.workOrderNumber, row.statusDescription)"
                      [ngClass]="getIconBgClass(row)">
                      <mat-icon matListIcon>attach_money</mat-icon>
                      <span matLine>Additional Info</span>
                    </button>
                  }
                  @if(controlPermissions.dispatchInfo){
                    <button mat-menu-item *ngIf="row.statusDescription !== 'Invoiced'" [disabled]="row.adsFlag"
                            [ngClass]="getDispatchColorClass(row)"
                            (click)="openDispatchInfo(row)">
                      <mat-icon matListIcon>redo</mat-icon>
                      <span matLine>Dispatch Info</span>
                    </button>
                  }
                </ng-container>
                @if(controlPermissions.sampleStatusChange && row.menuData?.sampleStatus !== 'L'){
                  <button class="sampledv" mat-menu-item (click)="
                      (row.menuData?.sampleStatus === null || row.menuData?.sampleStatus === 'null') ? setSampleStatus(row, 'S', '1') :
                      (row.menuData?.sampleStatus === 'S') ? setSampleStatus(row, 'T', null) :
                      (row.menuData?.sampleStatus === 'T') ? setSampleStatus(row, 'L', null) : null
                    " [disabled]="row.menuData?.sampleStatus === 'L'">
                    <mat-icon matListIcon>assignment</mat-icon>
                    <span matLine>
                      {{ (row.menuData?.sampleStatus === null || row.menuData?.sampleStatus === 'null') ? 'Take Sample - Permit' : row.sampleStatusToolTip}}
                    </span>
                  </button>
                  @if(row.menuData?.sampleStatus === null || row.menuData?.sampleStatus === 'null'){
                    <button class="sampledv" mat-menu-item (click)="setSampleStatus(row, 'S', '2')" [disabled]="row.menuData?.sampleStatus === 'L'">
                      <mat-icon matListIcon>assignment</mat-icon>
                      <span matLine>
                        {{ 'Take Sample - Storage' }}
                      </span>
                    </button>
                    <button class="sampledv" mat-menu-item (click)="setSampleStatus(row, 'S', '1,2')" [disabled]="row.menuData?.sampleStatus === 'L'">
                      <mat-icon matListIcon>assignment</mat-icon>
                      <span matLine>
                        {{ 'Take Sample - Permit and Storage' }}
                      </span>
                    </button>
                  }
                }
                <button mat-menu-item [disabled]="row.adsFlag"
                        (click)="openAttachDocuments(row.id, row.workOrderNumber)">
                  <mat-icon matListIcon>attach_file_add</mat-icon>
                  <span matLine>Attach docs</span>
                </button>
                <button mat-menu-item [disabled]="row.menuData?.loadSlip == 0"
                        [ngClass]="{ iconBGColor: row.menuData?.loadSlip > 0 }"
                        (click)="openViewDocsDialog(row.id, row.workOrderNumber, row)">
                  <mat-icon matListIcon>visibility</mat-icon>
                  <span matLine>View docs</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns();" [ngClass]="getRowClass(row)"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns().length">No data matching the filter.</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
